import {Debugger} from 'debug'

const debug:Debugger = require('debug')('Bygginformasjon');

declare const webpackdefine_bygginfo_version;
declare const webpackdefine_bygginfo_byggedato;
declare const webpackdefine_bygginfo_build_tag;
declare const webpackdefine_bygginfo_build_number;
declare const webpackdefine_bygginfo_job_name;

/** Informasjon om bygget. 
 * Se DefinePlugin i konfigurasjon/webpack-angular-utvidelse.config.ts som sørger for å erstatte webpackdefine-nøklene i kildekoden */
export class Bygginformasjon {

    static regNavn = "bygginformasjon"
    
    static opprettBygginformasjon(): Bygginformasjon {
        var bygginformasjon = new Bygginformasjon();
        debug('bygginformasjon %o', bygginformasjon);
        return bygginformasjon;
    }

    constructor() {
        this.version = webpackdefine_bygginfo_version;
        this.byggedato = webpackdefine_bygginfo_byggedato;
        this.build_tag = webpackdefine_bygginfo_build_tag;
        this.build_number = webpackdefine_bygginfo_build_number;
        this.jenkins_job_name = webpackdefine_bygginfo_job_name;
    }

    version = "";
    byggedato = "";
    build_tag = "";
    build_number = "";
    jenkins_job_name = "";
}
